import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';

@Injectable({
  providedIn: 'root'
})
export class SentryService {
  
  setUser(userId: string, email?: string, username?: string): void {
    Sentry.setUser({
      id: userId,
      email: email,
      username: username
    });
  }

  clearUser(): void {
    Sentry.setUser(null);
  }

  setTag(key: string, value: string): void {
    Sentry.setTag(key, value);
  }

  setContext(key: string, context: Record<string, any>): void {
    Sentry.setContext(key, context);
  }

  addBreadcrumb(message: string, category?: string, level?: Sentry.SeverityLevel, data?: Record<string, any>): void {
    Sentry.addBreadcrumb({
      message,
      category: category || 'app',
      level: level || 'info',
      data
    });
  }

  captureException(error: Error, context?: Record<string, any>): void {
    if (context) {
      Sentry.withScope((scope) => {
        Object.keys(context).forEach(key => {
          scope.setContext(key, context[key]);
        });
        Sentry.captureException(error);
      });
    } else {
      Sentry.captureException(error);
    }
  }

  captureMessage(message: string, level: Sentry.SeverityLevel = 'info', context?: Record<string, any>): void {
    if (context) {
      Sentry.withScope((scope) => {
        Object.keys(context).forEach(key => {
          scope.setContext(key, context[key]);
        });
        Sentry.captureMessage(message, level);
      });
    } else {
      Sentry.captureMessage(message, level);
    }
  }

  createTransaction(name: string, op: string): Sentry.Transaction {
    return Sentry.startTransaction({
      name,
      op
    });
  }

  profileComponent(componentName: string): void {
    this.addBreadcrumb(`Component ${componentName} initialized`, 'component', 'info');
  }

  profileApiCall(url: string, method: string, duration?: number, status?: number): void {
    this.addBreadcrumb(`API ${method} ${url}`, 'http', 'info', {
      duration,
      status,
      url,
      method
    });
  }

  profileUserAction(action: string, element?: string, data?: Record<string, any>): void {
    this.addBreadcrumb(`User ${action}`, 'user', 'info', {
      element,
      ...data
    });
  }
}